import '.a{display:flex;}.ssr-plugin'
import '.au{aspect-ratio:1/1;}.ssr-plugin'
import '.aq{flex-shrink:0;}.ssr-plugin'
import '.av{padding:0.5rem;}.ssr-plugin'
import '.aw{border-radius:0.625rem;}.ssr-plugin'
import '.ax{justify-content:center;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

type Variant = 'red' | 'blue' | 'gray'

const variantStyle: Record<Variant, Style> = {
  red: {
    color: 'var(--brand-primary)',
    background: '#FFE3E233',
  },
  blue: {
    color: 'var(--brand-secondary)',
    background: '#D9EEFF',
  },
  gray: {
    color: 'var(--brand-secondary)',
    background: 'var(--palette-blue-100)',
  },
}

const sizeStyle: Record<
  string,
  { width: string; height: string; iconFontSize: string }
> = {
  'extra-small': {
    width: '1.5rem',
    height: '1.5rem',
    iconFontSize: '1rem',
  },
  small: {
    width: '2rem',
    height: '2rem',
    iconFontSize: '1rem',
  },
  medium: {
    width: '3rem',
    height: '3rem',
    iconFontSize: '1.5625rem',
  },
  large: {
    width: '4rem',
    height: '4rem',
    iconFontSize: '2.5rem',
  },
}

export type IconProps = {
  variant?: Variant
  icon?: IconProp
  style?: Style
  size?: keyof typeof sizeStyle
}

export const Icon = ({ variant, icon, style, size = 'medium' }: IconProps) => {
  return (
    <styled.div className="a au aq av aw ax t"
      style={{
        width: sizeStyle[size].width,
        height: sizeStyle[size].height,
        ...(variant ? variantStyle[variant] : {}),
        ...style,
      }}
    >
      <FontAwesomeIcon
        icon={icon}
        style={{
          width: sizeStyle[size].iconFontSize,
          height: sizeStyle[size].iconFontSize,
        }}
      />
    </styled.div>
  )
}
